const Logout = () => {
    localStorage.removeItem('user-storage');
    window.location.href = '/'; 
}

export default Logout



